import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Services', path: '/services' }
  ];

  const supportLinks = [
    { name: 'Events', path: '/events' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: '📘', url: '#' },
    { name: 'Instagram', icon: '📷', url: '#' },
    { name: 'Twitter', icon: '🐦', url: '#' },
    { name: 'LinkedIn', icon: '💼', url: '#' }
  ];

  return (
    <footer className="footer-bg mt-auto">
      <Container>
        <Row className="py-5">
          {/* Company Info */}
          <Col lg={4} className="mb-4">
            <h3 className="fw-bold text-gradient mb-3">WiSE</h3>
            <p className="mb-3">
              Women SHG Enterprises - Empowering rural women through entrepreneurship 
              and sustainable livelihoods across Tamil Nadu.
            </p>
            <div className="mb-3">
              <p className="mb-1">📧 info@womenshgenterprises.com</p>
              <p className="mb-1">📞 +91-7397382501</p>
              <p className="mb-0">📍 73/3, Ground Floor, West Jones Road, West Saidapet, Chennai - 600 015</p>
            </div>
            <div className="d-flex gap-3">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.url} 
                  className="text-white-50 hover-effect"
                  style={{ fontSize: '1.5rem', transition: 'opacity 0.3s' }}
                  onMouseOver={(e) => e.target.style.opacity = '1'}
                  onMouseOut={(e) => e.target.style.opacity = '0.5'}
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={6} className="mb-4">
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              {quickLinks.map((link, index) => (
                <li key={index} className="mb-2">
                  <Link 
                    to={link.path} 
                    className="text-white-50 text-decoration-none hover-effect"
                    style={{ transition: 'color 0.3s' }}
                    onMouseOver={(e) => e.target.style.color = 'white'}
                    onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Support */}
          <Col lg={2} md={6} className="mb-4">
            <h5 className="fw-bold mb-3">Support</h5>
            <ul className="list-unstyled">
              {supportLinks.map((link, index) => (
                <li key={index} className="mb-2">
                  <Link 
                    to={link.path} 
                    className="text-white-50 text-decoration-none hover-effect"
                    style={{ transition: 'color 0.3s' }}
                    onMouseOver={(e) => e.target.style.color = 'white'}
                    onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Newsletter */}
          <Col lg={4} className="mb-4">
            <h5 className="fw-bold mb-3">Stay Updated</h5>
            <p className="mb-3">
              Subscribe to our newsletter for the latest updates on training programs, 
              new products, and success stories.
            </p>
            <div className="d-flex">
              <input 
                type="email" 
                className="form-control me-2" 
                placeholder="Enter your email"
                style={{ borderRadius: '25px 0 0 25px' }}
              />
              <button 
                className="btn btn-primary px-3"
                style={{ borderRadius: '0 25px 25px 0' }}
              >
                Subscribe
              </button>
            </div>
            <small className="text-white-50 mt-2 d-block">
              We respect your privacy. Unsubscribe anytime.
            </small>
          </Col>
        </Row>

        {/* Bottom Footer */}
        <Row className="border-top border-white border-opacity-25 py-4">
          <Col md={6}>
            <p className="mb-0 text-white-50">
              © 2024 Women SHG Enterprises (WiSE). All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-md-end">
            <div className="d-flex flex-wrap justify-content-md-end gap-3">
              <>
                Privacy Policy
              </>
              <>
                Terms of Service
              </>
              <>
                Cookie Policy
              </>
            </div>
          </Col>
        </Row>

        {/* Recognition */}
        <Row className="border-top border-white border-opacity-25 pt-4 pb-2">
          <Col className="text-center">
            <small className="text-white-50">
              Incubated under TANUVAS | Recognized by Tamil Nadu Government | 
              Supported by CFDT & SRMIST
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
